import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { PaymentIntentResult } from "@stripe/stripe-js";
import { injectStripe } from "ngx-stripe";
import { take } from "rxjs";

enum UpgradeProcessingStatus {
    Error = 0,
    Processing = 1,
    Complete = 2
}

@Component({
    imports: [BusySpinComponent],
    templateUrl: "./upgrade-complete.component.html"
})
export class UpgradeCompleteComponent {
    public isLoading: boolean = false;
    public upgradeStatus: UpgradeProcessingStatus = UpgradeProcessingStatus.Processing;
    public errorText?: string;

    private stripe = injectStripe();
    
    constructor(private events: EventBroker, private route: ActivatedRoute) {

    }
    
    public ngOnDestroy(): void {
        this.events.ui.restoreContentPaddingEvent.emit();
    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.removeContentPaddingEvent.emit();

        const queryParams = this.route.snapshot.queryParamMap;
        const paymentIntentId: string | null = queryParams.get("payment_intent");
        const paymentIntentClientSecret: string | null = queryParams.get("payment_intent_client_secret");

        if (paymentIntentId && paymentIntentClientSecret) {
            this.stripe
                .retrievePaymentIntent(paymentIntentClientSecret)
                .pipe(take(1))
                .subscribe({
                    next: (response: PaymentIntentResult) => {
                        if (response.paymentIntent) {
                            switch (response.paymentIntent.status) {
                                case "succeeded": 
                                    this.upgradeStatus = UpgradeProcessingStatus.Complete;
                                    break;

                                case "processing":
                                    this.upgradeStatus = UpgradeProcessingStatus.Processing;
                                    break;

                                case "requires_payment_method":
                                    this.upgradeStatus = UpgradeProcessingStatus.Error;
                                    this.errorText = "Payment failed. Please try another payment method.";
                                    break;

                                default:
                                    this.upgradeStatus = UpgradeProcessingStatus.Error;
                                    break;
                            }
                        } else if (response.error) {
                            this.upgradeStatus = UpgradeProcessingStatus.Error;
                            this.errorText = response.error.message;
                        } else {
                            this.upgradeStatus = UpgradeProcessingStatus.Error;
                        }
                    },
                    error: () => {
                        this.upgradeStatus = UpgradeProcessingStatus.Error;
                    }
                })
                .add(() => this.isLoading = false);
        } else {
            this.upgradeStatus = UpgradeProcessingStatus.Error;
            this.isLoading = false;
        }
    }
}